export default __webpack_public_path__ + "static/media/animal.e2a9910b.png";